import React from 'react';

import type { SVGProps } from 'react';

const CaretLeftIcon: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="7"
    height="12"
    viewBox="0 0 7 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 10.6L2.64865 6L7 1.4L5.67568 0L0 6L5.67568 12L7 10.6Z"
      fill="currentColor"
    />
  </svg>
);

export default CaretLeftIcon;
